import { GeneratePanel } from "@/components/GeneratePanel";

export default function Generate() {
  return (
    <div className="min-h-screen pt-24 pb-20 px-5 sm:px-8" data-testid="generate-page">
      <div className="max-w-4xl mx-auto">
        <GeneratePanel showHeader />
      </div>
    </div>
  );
}
